import { FamilyStepOption } from "@domain/product/monitoring/family/family-step-option";

/**
 * Normalizes device type strings for consistent comparison.
 * Converts to lowercase and removes hyphens and underscores.
 *
 * @example
 * normalizeDeviceType('KVM-T-IP') => 'kvmtip'
 * normalizeDeviceType('KVM_R_IP') => 'kvmrip'
 */
export function normalizeDeviceType(deviceType?: string): string | undefined {
  if (!deviceType) return undefined;
  return deviceType.toLowerCase().replace(/[-_]/g, "");
}

/**
 * Compares two FamilyStepOptions for equality, ignoring family context.
 * First compares by groupName if available, falls back to device set comparison.
 *
 * @example
 * optionsMatchIgnoringFamily(optionA, optionB) // true if same devices/group
 */
export function optionsMatchIgnoringFamily(a: FamilyStepOption, b: FamilyStepOption): boolean {
  const groupA = a.groupName?.trim() ?? "";
  const groupB = b.groupName?.trim() ?? "";

  if (groupA || groupB) {
    return groupA === groupB;
  }

  const devicesA = [...(a.devices ?? [])].map(String).sort().join("|");
  const devicesB = [...(b.devices ?? [])].map(String).sort().join("|");
  return devicesA === devicesB;
}
